import { HttpHeaders } from '@angular/common/http';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, map } from 'rxjs/operators';
import { environment } from 'environments/environment';
import { GlobalService } from 'app/shared/global.service';

@Injectable({
  providedIn: 'root'
})
export class saveChangePassword {
  isSessionVaild = true;
  constructor(private http: HttpClient, public router: Router, private globals: GlobalService) { this.isSessionVaild = true; }

  saveChangePassword(User) {
    const customHeaders = this.globals.GetCustomHeadersForPost();
    return this.http.post<any>(environment.apiUrl + 'login/saveChangePassword', User, { headers: new HttpHeaders(customHeaders) })
      .pipe(map(data => data),
        catchError((error: any) => {
          throw error;
        }));
  }
}


